import { render, staticRenderFns } from "./EdgeAuditorWaiver.vue?vue&type=template&id=a48aa1f0&scoped=true"
import script from "./EdgeAuditorWaiver.vue?vue&type=script&lang=ts"
export * from "./EdgeAuditorWaiver.vue?vue&type=script&lang=ts"
import style0 from "./EdgeAuditorWaiver.vue?vue&type=style&index=0&id=a48aa1f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48aa1f0",
  null
  
)

export default component.exports